import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import cn from 'classnames';

import { useLeadCardContext } from '@app/components/LeadCard/context';

import type { FC } from 'react';

import './AddActions.scss';

export const AddActions: FC = () => {
  const { addActionItems } = useLeadCardContext();

  return (
    <div className="AddActions">
      {addActionItems.map(({ id, label, onClick, icon, isFullWidth }) => (
        <Button
          key={id}
          size="small"
          className={cn('AddActions__button', {
            'AddActions__button--full-width': isFullWidth,
          })}
          icon={<FontAwesomeIcon icon={icon} />}
          onClick={onClick}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};
